import { Frame } from 'dragonmouse-shared/interfaces';

export class Transfer {}

export const TransferDragType = 'transferDrag';

// This is used to transfer an existing frame
export class TransferFrame extends Transfer {
	// TODO: consider changing this from a frame to a frameId
	constructor(public readonly frame: Frame) {
		super();
	}
}
